import { render, staticRenderFns } from "./zaixianbaoxiu.vue?vue&type=template&id=876fd89c&scoped=true&"
import script from "./zaixianbaoxiu.vue?vue&type=script&lang=js&"
export * from "./zaixianbaoxiu.vue?vue&type=script&lang=js&"
import style0 from "./zaixianbaoxiu.vue?vue&type=style&index=0&id=876fd89c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "876fd89c",
  null
  
)

export default component.exports